// extracted by mini-css-extract-plugin
module.exports = {"searchWrapper":"styles_searchWrapper__Kut2f","button":"styles_button__igWHa"};